import { useGlobal } from '@/utils/useGlobal';
import { Tabs } from 'antd';
import css from './index.module.scss';
import { TweenMax } from 'gsap';

export default function SwitchTabD() {
    const { useLang, isMobile, useEffect } = useGlobal();
    const { t } = useLang('dualfuelsmartgenerator');
    const tabs = [
        {
            tab: t('dg200.switchTabD_tab1_tab'),
            key: 'Gas',
            subs: [
                {
                    title: t('dg200.switchTabD_tab1_sub1_title'),
                    desc: t('dg200.switchTabD_tab1_sub1_desc'),
                    suffix: '',
                },
                {
                    title: t('dg200.switchTabD_tab1_sub2_title'),
                    desc: t('dg200.switchTabD_tab1_sub2_desc'),
                    suffix: '',
                },
                {
                    title: t('dg200.switchTabD_tab1_sub3_title'),
                    desc: t('dg200.switchTabD_tab1_sub3_desc'),
                    suffix: t('dg200.switchTabD_tab1_sub3_suffix'),
                },
            ],
        },
        {
            tab: t('dg200.switchTabD_tab2_tab'),
            key: 'LPG',
            subs: [
                {
                    title: t('dg200.switchTabD_tab2_sub1_title'),
                    desc: t('dg200.switchTabD_tab2_sub1_desc'),
                    suffix: '',
                },
                {
                    title: t('dg200.switchTabD_tab2_sub2_title'),
                    desc: t('dg200.switchTabD_tab2_sub2_desc'),
                    suffix: '',
                },
                {
                    title: t('dg200.switchTabD_tab2_sub3_title'),
                    desc: t('dg200.switchTabD_tab2_sub3_desc'),
                    suffix: t('dg200.switchTabD_tab2_sub3_suffix'),
                },
            ],
        },
    ];

    let controller: any;
    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        if (!isMobile) {
            const titleEl = document.querySelector('.dg200 .switchTabD .textBox .title') as HTMLElement;
            const titleH = titleEl?.offsetHeight < 150 ? 150 : titleEl?.offsetHeight;
            const scene1 = new ScrollMagic.Scene({
                triggerElement: '.dg200 .switchTabD .textBox .title',
                offset: 0,
                triggerHook: 1,
                duration: titleH,
            });
            const tween1 = TweenMax.fromTo('.dg200 .switchTabD .textBox .title', 0.5, { opacity: 0 }, { opacity: 0 });
            scene1.setTween(tween1);
            controller.addScene(scene1);

            const scene2 = new ScrollMagic.Scene({
                triggerElement: '.dg200 .switchTabD .textBox .title',
                offset: titleH,
                triggerHook: 1,
                duration: '40%',
            });
            const tween2 = TweenMax.fromTo('.dg200 .switchTabD .textBox .title', 0.5, { opacity: 0 }, { opacity: 1 });
            scene2.setTween(tween2);
            controller.addScene(scene2);

            const scene3 = new ScrollMagic.Scene({
                triggerElement: '.dg200 .switchTabD .textBox .title',
                offset: layoutH - titleH,
                triggerHook: 1,
                duration: titleH,
            });
            const tween3 = TweenMax.fromTo('.dg200 .switchTabD .textBox .title', 0.5, { opacity: 1 }, { opacity: 0 });
            scene3.setTween(tween3);
            controller.addScene(scene3);
        }
    }, []);

    useEffect(() => {
        if (!isMobile) {
            const descEl = document.querySelector('.dg200 .switchTabD .textBox .desc') as HTMLElement;
            const descH = descEl?.offsetHeight < 150 ? 150 : descEl?.offsetHeight;
            const scene1 = new ScrollMagic.Scene({
                triggerElement: '.dg200 .switchTabD .textBox .desc',
                offset: 0,
                triggerHook: 1,
                duration: descH,
            });
            const tween1 = TweenMax.fromTo('.dg200 .switchTabD .textBox .desc', 0.5, { opacity: 0 }, { opacity: 0 });
            scene1.setTween(tween1);
            controller.addScene(scene1);

            const scene2 = new ScrollMagic.Scene({
                triggerElement: '.dg200 .switchTabD .textBox .desc',
                offset: descH,
                triggerHook: 1,
                duration: '40%',
            });
            const tween2 = TweenMax.fromTo('.dg200 .switchTabD .textBox .desc', 0.5, { opacity: 0 }, { opacity: 1 });
            scene2.setTween(tween2);
            controller.addScene(scene2);

            const scene3 = new ScrollMagic.Scene({
                triggerElement: '.dg200 .switchTabD .textBox .desc',
                offset: layoutH - descH,
                triggerHook: 1,
                duration: descH,
            });
            const tween3 = TweenMax.fromTo('.dg200 .switchTabD .textBox .desc', 0.5, { opacity: 1 }, { opacity: 0 });
            scene3.setTween(tween3);
            controller.addScene(scene3);
        }
    }, []);

    useEffect(() => {
        if (!isMobile) {
            const tabsEl = document.querySelector('.dg200 .switchTabD .switchTabs') as HTMLElement;
            const tabsH = tabsEl?.offsetHeight < 150 ? 150 : tabsEl?.offsetHeight;
            const scene1 = new ScrollMagic.Scene({
                triggerElement: '.dg200 .switchTabD .switchTabs',
                offset: 0,
                triggerHook: 1,
                duration: tabsH,
            });
            const tween1 = TweenMax.fromTo('.dg200 .switchTabD .switchTabs', 0.5, { opacity: 0 }, { opacity: 0 });
            scene1.setTween(tween1);
            controller.addScene(scene1);

            const scene2 = new ScrollMagic.Scene({
                triggerElement: '.dg200 .switchTabD .switchTabs',
                offset: tabsH,
                triggerHook: 1,
                duration: '40%',
            });
            const tween2 = TweenMax.fromTo('.dg200 .switchTabD .switchTabs', 0.5, { opacity: 0 }, { opacity: 1 });
            scene2.setTween(tween2);
            controller.addScene(scene2);

            const scene3 = new ScrollMagic.Scene({
                triggerElement: '.dg200 .switchTabD .switchTabs',
                offset: layoutH - tabsH,
                triggerHook: 1,
                duration: tabsH,
            });
            const tween3 = TweenMax.fromTo('.dg200 .switchTabD .switchTabs', 0.5, { opacity: 1 }, { opacity: 0 });
            scene3.setTween(tween3);
            controller.addScene(scene3);
        }
    }, []);

    return (
        <div className={`switchTabD ${css.switchTabD} ${isMobile ? 'switchTabD_h5' : 'switchTabD_pc'}`}>
            <div className="container">
                <div className="textBox">
                    <p className="title">{t('dg200.switchTabD_title')}</p>
                    <p className="desc">{t('dg200.switchTabD_desc')}</p>
                </div>
                <div className="switchTabs">
                    <Tabs>
                        {tabs?.map((tab: any, _k: number) => (
                            <Tabs.TabPane key={tab?.key} tab={tab?.tab}>
                                {tab?.subs?.map((sub: any, l: number) => (
                                    <div className="specItem" key={l}>
                                        <div className="titleBox">
                                            <span className="title">{sub?.title}</span>
                                            <span className="suffix">{sub?.suffix}</span>
                                        </div>
                                        <p className="desc">{sub?.desc}</p>
                                    </div>
                                ))}
                            </Tabs.TabPane>
                        ))}
                    </Tabs>
                </div>
            </div>
        </div>
    );
}
